jQuery(".js-btn-select").click(function(){
  jQuery(".filter-date").toggleClass("show");
});

jQuery(".js-btn-select").click(function(){
  jQuery(".js-btn-select").toggleClass("active");
});

jQuery(".button--search-icon").click(function(){
  jQuery(".form--search").toggleClass("show");
});

jQuery(".button--search-icon").click(function(){
  jQuery(".button--search-icon").toggleClass("close");
});
